import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, type TournamentStatus } from "@/lib/api";

export function useTournaments(params: {
  status?: TournamentStatus;
  from?: string;
  to?: string;
  page?: number;
  page_size?: number;
} = {}) {
  return useQuery({
    queryKey: ["tournaments", params],
    queryFn: () => api.listTournaments(params),
  });
}

export function useTournament(slug: string | undefined) {
  return useQuery({
    queryKey: ["tournament", slug],
    queryFn: () => api.getTournament(slug!),
    enabled: !!slug,
  });
}

export function useDeleteTournament() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (slug: string) => api.deleteTournament(slug),
    onSuccess: (_data, slug) => {
      qc.invalidateQueries({ queryKey: ["tournaments"] });
      qc.removeQueries({ queryKey: ["tournament", slug] });
    },
  });
}
